<template>
  <div class="">
    
    <div
      class="s-layout__index_header"
      
    >
      <div class="btn-group">
        <button
          type="button"
          @click="$router.push({ name: 'transactions-index' })"
          class="btn"
          :class="$route.name == 'transactions-index' ? 'active' : ''"
        >
          <i class="bi bi-currency-bitcoin"></i>

          Transactions 
        </button>

        
      </div>
    </div>

    <br />
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  mounted() {
    window.location;
  },
};
</script>
